// Cycle-free OmniCine dev catalog data leaf (no runtime imports).
export const OMNICINE_DEV_ASSET_CATALOG = [
  {
    key: "dev-video-a",
    mediaAssetId: "devVideoA",
    previewAssetId: "asset_vid_001",
    kind: "video",
    label: "Dev Video A",
    durSec: 6.0,
    mediaUrl: "/demo/omnicine-dev-video-a.mp4",
    previewTrackId: "v1",
    surfaces: ["mediaPanel", "previewShelf"],
    seedTags: ["demo", "video", "local", "omnicine"],
    ingestMetadata: {
      assetId: "devVideoA",
      sourceAssetId: "devVideoA",
      sourceHash: "devhash:devVideoA:v1",
      containerFormat: "mp4",
      schemaVersion: "phase1-av-v1",
      ingestId: "ingest:devVideoA",
      fileName: "omnicine-dev-video-a.mp4",
      sourceFileName: "omnicine-dev-video-a.mp4",
      title: "Dev Video A",
      scene: "DEV-01",
      take: 1,
      camera: "A-Cam",
      frameRate: 24,
      nativeWidth: 1920,
      nativeHeight: 1080,
      pixelAspectRatio: 1,
      displayAspectRatio: 16 / 9,
      colorSpace: "rec709",
      transferFunction: "gamma2.4",
      videoBitDepth: 8,
      sourceInSec: 0,
      sourceOutSec: 6,
      timecodeStart: "00:00:00:00",
      dropFrame: false,
      streamLayout: "video+embeddedAudio",
      importSource: "seedCatalog",
      ingestTimestamp: 1760000001000,
      offlineState: "online",
      analysisState: "ready",
      metadataRichnessScore: 0.82,
      proxyStatus: "ready",
      preferredTimelineProxyId: "proxy:devVideoA:timeline",
      preferredScrubProxyId: "proxy:devVideoA:scrub",
      proxies: [
        { id: "proxy:devVideoA:timeline", kind: "timeline_proxy", tier: "low", status: "ready", uri: "/demo/omnicine-dev-video-a.mp4", resolution: "960x540", codec: "h264", timecodeParity: "verified" },
        { id: "proxy:devVideoA:scrub", kind: "scrub_proxy", tier: "medium", status: "ready", uri: "/demo/omnicine-dev-video-a.mp4", resolution: "1280x720", codec: "h264", timecodeParity: "verified" },
      ],
      metadataVault: { source: "seedCatalog", quality: "demo" },
    },
  },
  {
    key: "dev-video-b",
    mediaAssetId: "devVideoB",
    previewAssetId: "asset_vid_002",
    kind: "video",
    label: "Dev Video B",
    durSec: 9.5,
    mediaUrl: "/demo/omnicine-dev-video-b.mp4",
    previewTrackId: "v1",
    surfaces: ["mediaPanel", "previewShelf"],
    seedTags: ["demo", "video", "local", "omnicine"],
    ingestMetadata: {
      assetId: "devVideoB",
      sourceAssetId: "devVideoB",
      sourceHash: "devhash:devVideoB:v1",
      containerFormat: "mp4",
      schemaVersion: "phase1-av-v1",
      ingestId: "ingest:devVideoB",
      fileName: "omnicine-dev-video-b.mp4",
      sourceFileName: "omnicine-dev-video-b.mp4",
      title: "Dev Video B",
      scene: "DEV-02",
      take: 2,
      camera: "B-Cam",
      frameRate: 24,
      nativeWidth: 1920,
      nativeHeight: 1080,
      pixelAspectRatio: 1,
      displayAspectRatio: 16 / 9,
      colorSpace: "rec709",
      transferFunction: "gamma2.4",
      videoBitDepth: 8,
      sourceInSec: 0,
      sourceOutSec: 9.5,
      timecodeStart: "00:00:10:00",
      dropFrame: false,
      streamLayout: "video+embeddedAudio",
      importSource: "seedCatalog",
      ingestTimestamp: 1760000002000,
      offlineState: "online",
      analysisState: "partial",
      metadataRichnessScore: 0.74,
      proxyStatus: "ready",
      preferredTimelineProxyId: "proxy:devVideoB:timeline",
      preferredScrubProxyId: "proxy:devVideoB:scrub",
      proxies: [
        { id: "proxy:devVideoB:timeline", kind: "timeline_proxy", tier: "low", status: "ready", uri: "/demo/omnicine-dev-video-b.mp4", resolution: "960x540", codec: "h264", timecodeParity: "verified" },
        { id: "proxy:devVideoB:scrub", kind: "scrub_proxy", tier: "medium", status: "ready", uri: "/demo/omnicine-dev-video-b.mp4", resolution: "1280x720", codec: "h264", timecodeParity: "verified" },
      ],
      metadataVault: { source: "seedCatalog", quality: "demo" },
    },
  },
  {
    key: "hero-poster",
    mediaAssetId: "heroPoster",
    previewAssetId: "asset_img_001",
    kind: "image",
    label: "Hero Poster",
    durSec: 5.0,
    mediaUrl: "/images/hero-poster.jpg",
    previewTrackId: "v1",
    surfaces: ["mediaPanel"],
    seedTags: ["demo", "image", "poster", "local", "omnicine"],
    ingestMetadata: {
      assetId: "heroPoster",
      sourceAssetId: "heroPoster",
      sourceHash: "devhash:heroPoster:v1",
      containerFormat: "jpg",
      schemaVersion: "phase1-av-v1",
      ingestId: "ingest:heroPoster",
      fileName: "hero-poster.jpg",
      sourceFileName: "hero-poster.jpg",
      title: "Hero Poster",
      importSource: "seedCatalog",
      ingestTimestamp: 1760000003000,
      offlineState: "online",
      analysisState: "ready",
      metadataRichnessScore: 0.58,
      proxyStatus: "ready",
      preferredTimelineProxyId: "proxy:heroPoster:timeline",
      proxies: [
        { id: "proxy:heroPoster:timeline", kind: "timeline_proxy", tier: "low", status: "ready", uri: "/images/hero-poster.jpg", resolution: "1600x900", codec: "jpeg", timecodeParity: "verified" },
      ],
      metadataVault: { source: "seedCatalog", still: true },
    },
  },
  {
    key: "dev-audio-bed",
    mediaAssetId: "devAudioBed",
    previewAssetId: "asset_aud_001",
    kind: "audio",
    label: "Dev Audio Bed",
    durSec: 12.0,
    mediaUrl: "/assets/audio/whisper_calibration_complete.mp3",
    previewTrackId: "a1",
    surfaces: ["mediaPanel", "previewShelf"],
    seedTags: ["demo", "audio", "local", "omnicine"],
    ingestMetadata: {
      assetId: "devAudioBed",
      sourceAssetId: "devAudioBed",
      sourceHash: "devhash:devAudioBed:v1",
      containerFormat: "mp3",
      schemaVersion: "phase1-av-v1",
      ingestId: "ingest:devAudioBed",
      fileName: "whisper_calibration_complete.mp3",
      sourceFileName: "whisper_calibration_complete.mp3",
      title: "Dev Audio Bed",
      sampleRate: 48000,
      channelCount: 2,
      channelLayout: "stereo",
      audioBitDepth: 16,
      audioCodec: "mp3",
      sourceInSec: 0,
      sourceOutSec: 12,
      timecodeStart: "00:00:00:00",
      importSource: "seedCatalog",
      ingestTimestamp: 1760000004000,
      offlineState: "online",
      analysisState: "ready",
      metadataRichnessScore: 0.79,
      proxyStatus: "ready",
      preferredTimelineProxyId: "proxy:devAudioBed:waveform",
      preferredScrubProxyId: "proxy:devAudioBed:waveform",
      proxies: [
        { id: "proxy:devAudioBed:waveform", kind: "waveform_proxy", tier: "low", status: "ready", uri: "/assets/audio/whisper_calibration_complete.mp3", resolution: "audio-envelope", codec: "mp3", timecodeParity: "verified" },
      ],
      metadataVault: { source: "seedCatalog", quality: "demo" },
    },
  },
] as const;
